module.exports = function() {
  return new Worker(__webpack_public_path__ + "f3873fdcad5c8923c6f7.worker.js");
};